/* eslint-disable import/no-cycle */
import { IconButton, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@/assets/img/ic_modal_close.svg";
import { useHistory, Link } from "react-router-dom";
import Divider from "@mui/material/Divider";
import { getCompanyInfo, getCurrentPlan } from "@/redux/organization/selector";
import { useSelector } from "react-redux";
import useOrganizationInfoRequestThunk from "@/hooks/Organization/useOrganizationInfoRequestThunk";
import useGetUserInfoRequest from "@/hooks/user/useGetUserInfoRequest";

function DeleteAccount() {
	const history = useHistory();
	const companyInfo = useSelector(getCompanyInfo);
	const currentPlan = useSelector(getCurrentPlan);

	const handleClickClose = () => history.goBack();
	useOrganizationInfoRequestThunk();
	useGetUserInfoRequest();
	return (
		<div style={{ height: "100vh" }}>
			<div style={{ display: "flex", justifyContent: "flex-end", padding: "2rem" }}>
				<IconButton size="medium" onClick={handleClickClose}>
					<img src={CloseIcon} alt="close" />
				</IconButton>
			</div>

			<div
				style={{
					maxWidth: "1250px",
					margin: "auto",
				}}
			>
				<h1 style={{ fontSize: "2.5rem" }}>계정 삭제 가이드</h1>
				<p style={{ marginTop: "2rem", fontSize: "18px", lineHeight: "1.5rem" }}>
					Owner(오너)의 계정을 삭제하기 위해선 몇가지 스텝들을 밟아야 합니다.
					<br />
					아래 주의사항을 천천히 읽으신후 순서대로 진행 부탁드립니다
				</p>
				<Divider sx={{ marginTop: "1.5rem" }} />
				<ul
					style={{
						marginTop: "2rem",
						color: "#FF0000",
						fontSize: "15px",
						lineHeight: "2rem",
					}}
				>
					<li style={{ listStyle: "inside" }}>
						푸드렌즈는 구독을 해지해도 결제된 기간까지는 구독기간이
						유지됩니다. 따라서 구독기간이 끝날때까지 계정삭제가 불가능합니다.
					</li>
					<li style={{ listStyle: "inside" }}>
						구독기간이 끝난후 계정 삭제시 기존의 데이터, 계정정보 등은 복구가
						불가능합니다.
					</li>
					<li style={{ listStyle: "inside" }}>
						구독기간이 끝난후 계정 삭제시 결제 식별정보, 결제 이력등 복구가
						불가능합니다.
					</li>
					<li style={{ listStyle: "inside" }}>
						구독기간이 남아있는 동안에는 최소 1개의 어플리케이션(App)이
						등록되어있는 상태여야 합니다. 어플리케이션을 모두 삭제하시려면
						구독기간이 끝날때 까지 기다려주세요.
					</li>
				</ul>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						maxWidth: "1250px",
						marginTop: "4rem",
					}}
				>
					<div
						style={{
							border: "2px solid #E0E0E0",
							flexGrow: "1",
							margin: "1rem",
							height: "250px",
							borderRadius: "6px",
							padding: "1.5rem ",
						}}
					>
						<h2>STEP 01</h2>
						<Typography sx={{ marginTop: "1rem", whiteSpace: "nowrap" }}>
							현재 진행중인 구독 취소하기
						</Typography>
						{/* <Link to="/organization/billing/information"> */}
						<Link to="/organization/billing/applicationList">
							<span
								style={{
									marginTop: "1rem",
									color: "#0071E3",
									textDecoration: "underline",
									display: "block",
								}}
							>
								바로가기
							</span>
						</Link>
						<svg
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								marginTop: "5rem",
							}}
						>
							<path
								d="M30.6663 16L27.413 12.28L27.8663 7.36L23.053 6.26667L20.533 2L15.9997 3.94667L11.4663 2L8.94634 6.25333L4.13301 7.33333L4.58634 12.2667L1.33301 16L4.58634 19.72L4.13301 24.6533L8.94634 25.7467L11.4663 30L15.9997 28.04L20.533 29.9867L23.053 25.7333L27.8663 24.64L27.413 19.72L30.6663 16ZM13.453 22.2933L8.38634 17.2133L10.3597 15.24L13.453 18.3467L21.253 10.52L23.2263 12.4933L13.453 22.2933Z"
								fill={companyInfo?.nextPaymentAt ? "#DBE0E4" : "#0071E3"}
							/>
						</svg>
					</div>
					<div
						style={{
							border: "2px solid #E0E0E0",
							flexGrow: 1,
							margin: "1rem",
							height: "250px",
							borderRadius: "6px",
							padding: "1.5rem",
						}}
					>
						<h2>STEP 02</h2>
						<Typography sx={{ marginTop: "1rem", whiteSpace: "nowrap" }}>
							구독 종료 시점까지 기다리기
						</Typography>
						<Link to="/organization/general">
							<span
								style={{
									marginTop: "1rem",
									color: "#0071E3",
									textDecoration: "underline",
									display: "block",
								}}
							>
								바로가기
							</span>
						</Link>
						<svg
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								marginTop: "5rem",
							}}
						>
							<path
								d="M30.6663 16L27.413 12.28L27.8663 7.36L23.053 6.26667L20.533 2L15.9997 3.94667L11.4663 2L8.94634 6.25333L4.13301 7.33333L4.58634 12.2667L1.33301 16L4.58634 19.72L4.13301 24.6533L8.94634 25.7467L11.4663 30L15.9997 28.04L20.533 29.9867L23.053 25.7333L27.8663 24.64L27.413 19.72L30.6663 16ZM13.453 22.2933L8.38634 17.2133L10.3597 15.24L13.453 18.3467L21.253 10.52L23.2263 12.4933L13.453 22.2933Z"
								fill={
									currentPlan?.paymentPlan?.remainingDays
										? "#DBE0E4"
										: "#0071E3"
								}
							/>
						</svg>
					</div>
					<div
						style={{
							border: "2px solid #E0E0E0",
							flexGrow: 1,
							margin: "1rem",
							height: "250px",
							borderRadius: "6px",
							padding: "1.5rem",
						}}
					>
						<h2>STEP 03</h2>
						<Typography sx={{ marginTop: "1rem", whiteSpace: "nowrap" }}>
							계정에 속해있는 앱(들) 삭제하기
						</Typography>
						<Link to="/organization/applications">
							<span
								style={{
									marginTop: "1rem",
									color: "#0071E3",
									textDecoration: "underline",
									display: "block",
								}}
							>
								바로가기
							</span>
						</Link>
						<svg
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								marginTop: "5rem",
							}}
						>
							<path
								d="M30.6663 16L27.413 12.28L27.8663 7.36L23.053 6.26667L20.533 2L15.9997 3.94667L11.4663 2L8.94634 6.25333L4.13301 7.33333L4.58634 12.2667L1.33301 16L4.58634 19.72L4.13301 24.6533L8.94634 25.7467L11.4663 30L15.9997 28.04L20.533 29.9867L23.053 25.7333L27.8663 24.64L27.413 19.72L30.6663 16ZM13.453 22.2933L8.38634 17.2133L10.3597 15.24L13.453 18.3467L21.253 10.52L23.2263 12.4933L13.453 22.2933Z"
								fill={companyInfo?.appCount ? "#DBE0E4" : "#0071E3"}
							/>
						</svg>
					</div>
					<div
						style={{
							border: "2px solid #E0E0E0",
							flexGrow: 1,
							margin: "1rem",
							height: "250px",
							borderRadius: "6px",
							padding: "1.5rem",
						}}
					>
						<h2>STEP 04</h2>
						<Typography sx={{ marginTop: "1rem", whiteSpace: "nowrap" }}>
							계정에 속해있는 멤버(들)삭제하기
						</Typography>
						<Link to="/organization/members">
							<span
								style={{
									marginTop: "1rem",
									color: "#0071E3",
									textDecoration: "underline",
									display: "block",
								}}
							>
								바로가기
							</span>
						</Link>
						<svg
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							style={{
								marginTop: "5rem",
							}}
						>
							<path
								d="M30.6663 16L27.413 12.28L27.8663 7.36L23.053 6.26667L20.533 2L15.9997 3.94667L11.4663 2L8.94634 6.25333L4.13301 7.33333L4.58634 12.2667L1.33301 16L4.58634 19.72L4.13301 24.6533L8.94634 25.7467L11.4663 30L15.9997 28.04L20.533 29.9867L23.053 25.7333L27.8663 24.64L27.413 19.72L30.6663 16ZM13.453 22.2933L8.38634 17.2133L10.3597 15.24L13.453 18.3467L21.253 10.52L23.2263 12.4933L13.453 22.2933Z"
								fill={
									companyInfo !== null && companyInfo?.userCount > 1
										? "#DBE0E4"
										: "#0071E3"
								}
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
}

export default DeleteAccount;
